import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import "./MobileFooterNavbar.scss";
import { palette } from "../../styles/palette";
import { Link, useLocation } from "react-router-dom";
import {
  AccountCircle,
  EmojiEventsOutlined,
  GroupsOutlined,
  LeaderboardOutlined,
  SportsSoccer,
} from "@mui/icons-material";

export interface MobileFooterNavbarProps {}

export const MobileFooterNavbar: React.FC<MobileFooterNavbarProps> = () => {
  const { pathname } = useLocation();
  // Derive the active tab from the route so the selected state stays correct on
  // first paint, refresh, and back/forward navigation.
  const activePath =
    navigationProps.find((navProp) => pathname.startsWith(navProp.routePath))
      ?.routePath ?? false;

  return (
    <div className="MobileFooterNavbarLayout">
      <BottomNavigation className="mobileFooterNavbar__nav" value={activePath}>
        {navigationProps.map((navProp) => (
          <Link
            key={`${navProp.name} route`}
            to={navProp.routePath}
            className="mobileFooterNavbar__link"
          >
            <BottomNavigationAction
              value={navProp.routePath}
              label={navProp.name}
              icon={navProp.icon}
              showLabel
              style={{
                fontWeight: "600",
                color: activePath === navProp.routePath ? palette.accent : undefined,
              }}
            />
          </Link>
        ))}
      </BottomNavigation>
    </div>
  );
};

const navigationProps = [
  {
    name: "Predictions",
    routePath: "/bets",
    icon: <EmojiEventsOutlined />,
  },
  {
    name: "Fixtures",
    routePath: "/fixtures",
    icon: <SportsSoccer />,
  },
  {
    name: "Rankings",
    routePath: "/ranking",
    icon: <LeaderboardOutlined />,
  },
  {
    name: "Leagues",
    routePath: "/leagues",
    icon: <GroupsOutlined />,
  },
  {
    name: "Profile",
    routePath: "/profile",
    icon: <AccountCircle />,
  },
];
